import React from 'react'
import { motion } from "framer-motion";
// import { Link } from "react-scroll";

function Testimonials() {
  return (
    <div>
         {/* ===== TESTIMONIALS ===== */}
      <section className="testimonials" id='services'>
        <h2 className="section__title">Premier Services</h2>
        <div className="container testimonials__grid">
          {[
            {
              name: "Someone",
              role: "Corporate Lawyer",
              text: "This AI saved me hours every week. The insights are incredibly accurate!",
            },
            {
              name: "Someone",
              role: "Startup Founder",
              text: "We use it daily for NDAs and contracts — it’s a game changer.",
            },
            {
              name: "Someone",
              role: "Legal Consultant",
              text: "Fantastic interface and excellent customer support. Highly recommend!",
            },
            {
              name: "Someone",
              role: "Corporate Lawyer",
              text: "This AI saved me hours every week. The insights are incredibly accurate!",
            },
            {
              name: "Someone",
              role: "Startup Founder",
              text: "We use it daily for NDAs and contracts — it’s a game changer.",
            },
            {
              name: "Someone",
              role: "Legal Consultant",
              text: "Fantastic interface and excellent customer support. Highly recommend!",
            },
            {
              name: "Someone",
              role: "Startup Founder",
              text: "We use it daily for NDAs and contracts — it’s a game changer.",
            },
            {
              name: "Someone",
              role: "Legal Consultant",
              text: "Fantastic interface and excellent customer support. Highly recommend!",
            },
          ].map((t, i) => (
            <motion.div
              className="testimonial"
              key={i}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              {/* <p>“{t.text}”</p> */}
              <h4>Modular Kitchen</h4>
              <span>Sleek , modern & functional kitchen</span>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Testimonials